module.exports = __webpack_public_path__ + "img/4.ecb9114c.png";